import { render, staticRenderFns } from "./column3-charts.vue?vue&type=template&id=93ea1af8&scoped=true"
import script from "./column3-charts.vue?vue&type=script&lang=ts"
export * from "./column3-charts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ea1af8",
  null
  
)

export default component.exports